import React, { useState } from 'react';
import { MessageCircle, X, Send, UserRound } from 'lucide-react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { WHATSAPP_NUMBER } from '../data/constants';
const QUICK_REPLIES = ['👋 Je veux parler à un humain', 'Je souhaite candidater à une formation', 'Je suis une entreprise et je veux recruter un alternant', 'Infos sur le BTS NDRC / TP Conseiller de Vente'];
export function WhatsAppChat() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const wantsHuman = /humain|conseiller|quelqu'?un|une personne|parler/i.test(message);
  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim()) return;
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    setMessage('');
    setIsOpen(false);
  };
  return <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end" data-id="element-551" data-mp="2uwrjjzsa0ug0">
      {isOpen && <div role="dialog" aria-label="Chat WhatsApp Zillenium Alternance" className="bg-white w-[calc(100vw-3rem)] sm:w-[380px] rounded-3xl shadow-2xl border border-slate-100 mb-4 overflow-hidden animate-in slide-in-from-bottom-5 fade-in-50 duration-300" data-id="element-552" data-mp="c9rtenda7kib">
          <div className="h-1.5 w-full bg-brand-orange" data-id="element-553" data-mp="7d1hmc8ifb2p" />

          {/* En-tête */}
          <div className="bg-primary-dark p-4 flex items-center justify-between text-white" data-id="element-554" data-mp="v2vrqm1g2lj9">
            <div className="flex items-center gap-3" data-id="element-555" data-mp="zzvw8sinbg89">
              <div className="w-10 h-10 bg-brand-orange rounded-full flex items-center justify-center shrink-0" data-id="element-556" data-mp="102qfwhtu4x0m">
                <MessageCircle className="w-6 h-6 text-white" data-id="element-557" data-mp="qaui77vnv8wx" />
              </div>
              <div data-id="element-558" data-mp="q8rjlzgg07gl">
                <h3 className="font-bold font-heading text-sm" data-id="element-559" data-mp="1e0yjv9pagyla">
                  Zillenium Alternance
                </h3>
                <p className="text-xs text-lavande flex items-center gap-1.5" data-id="element-560" data-mp="1isgllzz4z37b">
                  <span className="w-2 h-2 rounded-full bg-green-400 inline-block" data-id="element-561" data-mp="1snxaj2gbnoyy" />
                  En ligne · répond rapidement
                </p>
              </div>
            </div>
            <button onClick={() => setIsOpen(false)} className="text-white/80 hover:text-white transition-colors p-1 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-white" aria-label="Fermer le chat" data-id="element-562" data-mp="1ioxz5c469f89">
              <X className="w-5 h-5" data-id="element-563" data-mp="19qcl9u9naodt" />
            </button>
          </div>

          {/* Corps */}
          <div className="p-5 bg-slate-50 max-h-[320px] overflow-y-auto flex flex-col gap-4" data-id="element-564" data-mp="14vzypbcvgwxu">
            <div className="bg-white p-4 rounded-2xl rounded-tl-none shadow-sm border border-slate-100 self-start max-w-[90%]" data-id="element-565" data-mp="zwn94ium9brk">
              <p className="text-sm text-primary-dark leading-relaxed" data-id="element-566" data-mp="qxs3p8zec5pb">
                Bonjour 👋 Une question sur nos formations, l'alternance ou une
                candidature ? Écrivez-nous, on vous répond sur WhatsApp.
              </p>
            </div>

            <div className="flex flex-wrap gap-2" data-id="element-567" data-mp="2xoepn26lfdsf">
              {QUICK_REPLIES.map(reply => <button key={reply} type="button" onClick={() => setMessage(reply)} className="text-xs font-medium bg-lavande text-primary-dark rounded-full px-3 py-1.5 hover:bg-lavande/70 transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange" data-id="element-568" data-mp="32nhwms64vu31">
                  {reply}
                </button>)}
            </div>

            {wantsHuman && <div className="bg-primary-dark text-white p-4 rounded-2xl rounded-tl-none shadow-sm self-start max-w-[90%] flex gap-3 items-start animate-in fade-in-50" data-id="element-569" data-mp="2nv65lh7a8nvq">
                <div className="w-8 h-8 bg-brand-orange rounded-full flex items-center justify-center shrink-0" data-id="element-570" data-mp="1v721h04d0iv5">
                  <UserRound className="w-4 h-4 text-white" data-id="element-571" data-mp="205bylg9n9tje" />
                </div>
                <p className="text-sm leading-relaxed text-lavande" data-id="element-572" data-mp="6p8v253km5ng">
                  Parfait, je vous mets en relation avec un conseiller. Cliquez
                  sur <span className="font-bold text-white" data-id="element-573" data-mp="fghn6xz18odh">Envoyer</span> : la
                  conversation s'ouvre directement avec notre équipe sur
                  WhatsApp.
                </p>
              </div>}
          </div>

          {/* Saisie */}
          <div className="p-4 bg-white border-t border-slate-100" data-id="element-574" data-mp="pcufbrexiu64">
            <form onSubmit={handleSend} className="flex gap-2" data-id="element-575" data-mp="kej53fkq2hnd">
              <Input value={message} onChange={e => setMessage(e.target.value)} placeholder="Votre message..." aria-label="Votre message" className="flex-1 rounded-full border-slate-200 focus-visible:ring-brand-orange bg-slate-50 px-4" data-id="element-576" data-mp="yfdhsaesz4ru" />
              <Button type="submit" size="icon" className="rounded-full bg-brand-orange hover:bg-[#E67E22] text-white shrink-0 shadow-md transition-transform hover:scale-105" disabled={!message.trim()} aria-label="Envoyer sur WhatsApp" data-id="element-577" data-mp="2w66khhhcbiuw">
                <Send className="w-4 h-4 ml-0.5" data-id="element-578" data-mp="2cb52iqozaf3f" />
              </Button>
            </form>
          </div>
        </div>}

      {!isOpen && <button onClick={() => setIsOpen(true)} className="w-16 h-16 bg-brand-orange hover:bg-[#E67E22] text-white rounded-full shadow-xl flex items-center justify-center hover:scale-110 transition-transform duration-300 group relative focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2" aria-label="Ouvrir le chat WhatsApp" data-id="element-579" data-mp="22cpgh24t5w0s">
          <span className="absolute inset-0 rounded-full bg-brand-orange animate-ping opacity-20" data-id="element-580" data-mp="3nrll2svtxbui" />
          <MessageCircle className="w-8 h-8 relative z-10" data-id="element-581" data-mp="3solr53soielm" />
        </button>}
    </div>;
}